<div class="indicator-small" *ngIf="progress && !uiError">
  <div class="mk-spinner-wrap">
    <div class="mk-spinner-pie"></div>
  </div>
  <div class="message" *ngIf="message">
    {{ message }}
  </div>
</div>

<div class="gh-empty-module" *ngIf="uiError">
  <div class="gh-error-indicator-inline">
    <span class="gh-fe">
      <span *ngIf="uiError.title">{{ uiError.title | localize }}</span>
      <span *ngIf="uiError.body">{{ uiError.body }}</span
      >&nbsp; <span *ngIf="uiError.transactionId">{{ "transaction_id" | localize }}: {{ uiError.transactionId }}</span
      >&nbsp;
      <span class="gh-input-text-clear" (click)="reset()">
        <span class="gh-clear-input">
          <ui-icon [uiClass]="'ui-1_bold-remove'"></ui-icon>
        </span>
      </span>
    </span>
  </div>
</div>
